import { render } from "./Res.vue?vue&type=template&id=5a14a8a1"
import script from "./Res.vue?vue&type=script&lang=js"
export * from "./Res.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__